import { IoPerson } from "react-icons/io5";
import classNames from "./Testimonies.module.css";

import { useEffect, useMemo, useState } from "react";

const Testimonies = (props: {
  testimonies: {
    companyImage: string;
    quote: string;
    name: string;
    title: string;
    image: string;
  }[];
  theme: "dark" | "light";
}) => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(false);
  const [clicked, setClicked] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Stop auto-carousel on interaction
    if (clicked !== undefined) {
      return;
    }

    const interval = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % props.testimonies.length);
        setFade(false);
      }, 1000); // Needs to match css transition length
    }, 10 * 1000);

    return () => clearInterval(interval);
  }, [props.testimonies, clicked]);

  const current = useMemo(() => {
    return props.testimonies[index];
  }, [props.testimonies, index]);

  return (
    <div className={classNames.Testimonies}>
      <div
        className={`${classNames.Testimony} ${fade ? classNames.FadeOut : ""}`}
      >
        <div className={classNames.Image}>
          <img src={current.companyImage} alt="Company" />
        </div>
        <div className={classNames.Current}>
          <div className={classNames.Quote}>
            <h2>"{current.quote}"</h2>
          </div>
          <div className={classNames.Customer}>
            {current.image ? (
              <img src={current.image} alt={current.name} />
            ) : (
              <IoPerson />
            )}
            <div>
              <h3>{current.name}</h3>
              <h3>{current.title}</h3>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${classNames.Dots} ${
          props.theme === "light" ? classNames.Light : classNames.Dark
        }`}
      >
        {props.testimonies.map((_, i) => (
          <div
            key={i}
            data-active={clicked !== undefined ? clicked === i : index === i}
            onClick={() => {
              setClicked(i);
              setFade(true);
              setTimeout(() => {
                setIndex(i);
                setFade(false);
                setClicked(undefined);
              }, 1000);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonies;
